import React from 'react';
import MultiSelect from '@/components/ui/multi-select';
import { LazySection } from '@/components/ui/LazySection';

interface CROFilterBarProps {
  countryOptions: string[];
  serviceTypeOptions: string[];
  therapeuticAreaOptions: string[];
  technologyOptions: { id: string; name: string }[];
  platformOptions: { id: string; name: string }[];
  instrumentOptions: { id: string; name: string }[];
  softwareOptions: { id: string; name: string }[];
  complianceOptions: string[];
  selectedCountries: string[];
  setSelectedCountries: (v: string[]) => void;
  selectedServiceTypes: string[];
  setSelectedServiceTypes: (v: string[]) => void;
  selectedTherapeuticAreas: string[];
  setSelectedTherapeuticAreas: (v: string[]) => void;
  selectedTechnologies: string[];
  setSelectedTechnologies: (v: string[]) => void;
  selectedPlatforms: string[];
  setSelectedPlatforms: (v: string[]) => void;
  selectedInstruments: string[];
  setSelectedInstruments: (v: string[]) => void;
  selectedSoftware: string[];
  setSelectedSoftware: (v: string[]) => void;
  selectedCompliances: string[];
  setSelectedCompliances: (v: string[]) => void;
  techLoading?: boolean;
  platformLoading?: boolean;
  productsLoading?: boolean;
}

export default function CROFilterBar(props: CROFilterBarProps) {
  return (
    <LazySection minHeight={60}>
      <div className="w-full mb-6">

        
        {/* Filter Grid - Two Rows of 4 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {/* Row 1 - First 4 filters */}
          <MultiSelect
            options={props.countryOptions.map((country) => ({ label: country, value: country }))}
            selected={props.selectedCountries}
            onChange={props.setSelectedCountries}
            placeholder="Location"
            disabled={false}
          />
          <MultiSelect
            options={props.serviceTypeOptions.map((type) => ({ label: type, value: type }))}
            selected={props.selectedServiceTypes}
            onChange={props.setSelectedServiceTypes}
            placeholder="Service Types"
            disabled={false}
          />
          <MultiSelect
            options={props.therapeuticAreaOptions.map((area) => ({ label: area, value: area }))}
            selected={props.selectedTherapeuticAreas}
            onChange={props.setSelectedTherapeuticAreas}
            placeholder="Therapeutic Areas"
            disabled={false}
          />
          <MultiSelect
            options={props.technologyOptions.map((tech) => ({ label: tech.name, value: tech.id }))}
            selected={props.selectedTechnologies}
            onChange={props.setSelectedTechnologies}
            placeholder="Technology"
            disabled={props.techLoading}
          />
          
          {/* Row 2 - Last 4 filters */}
          <MultiSelect
            options={props.platformOptions.map((platform) => ({ label: platform.name, value: platform.id }))}
            selected={props.selectedPlatforms}
            onChange={props.setSelectedPlatforms}
            placeholder="Platforms"
            disabled={props.platformLoading}
          />
          <MultiSelect
            options={props.instrumentOptions.map((inst) => ({ label: inst.name, value: inst.id }))}
            selected={props.selectedInstruments}
            onChange={props.setSelectedInstruments}
            placeholder="Instruments"
            disabled={props.productsLoading}
          />
          <MultiSelect
            options={props.softwareOptions.map((soft) => ({ label: soft.name, value: soft.id }))}
            selected={props.selectedSoftware}
            onChange={props.setSelectedSoftware}
            placeholder="Software"
            disabled={props.productsLoading}
          />
          <MultiSelect
            options={props.complianceOptions.map((comp) => ({ label: comp, value: comp }))}
            selected={props.selectedCompliances}
            onChange={props.setSelectedCompliances}
            placeholder="Compliance"
            disabled={false}
          />
        </div>
      </div>
    </LazySection>
  );
} 